import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * We've found multiple issues with using cross-file `compose` syntax in CSS modules directly.
 * This file results in the same functionality but composes via JS rather than CSS.
 *
 * A couple of the issues:
 * https://github.com/webpack-contrib/css-loader/issues/636
 * https://github.com/faceyspacey/extract-css-chunks-webpack-plugin/issues/55
 */
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';
import * as CSSModules from './image.module.less';
export default _objectSpread(_objectSpread({}, CSSModules), {}, {
  sizer: classNames(CSSModules.sizer, classes('float-left')),
  container: classNames(CSSModules.container, classes('width-100', 'position-relative')),
  image: classNames(CSSModules.image, classes('width-100', 'display-block')),
  lazyload: classNames(CSSModules.lazyload, classes('width-100')),
  children: classNames(CSSModules.children, classes('width-100', 'display-block')),
  'react-lazyload-placeholder': classNames(CSSModules['react-lazyload-placeholder'], classes('width-100', 'display-block', 'position-absolute')),
  figure: classNames(CSSModules.figure, classes('display-flex', 'flex-direction-column')),
  figcaption: classNames(CSSModules.figcaption, classes('flex-none'))
});